import React from "react";
import LinkWithMessageBubble from "shared/components/LinkWithMessageBubble";

export const Intercom: React.FC<{ intercomAppId: string, cookiesAllowed: boolean, openCookieConsentBanner: () => void }> = ({ intercomAppId, cookiesAllowed, openCookieConsentBanner }) => {
    if (intercomAppId === "") {
        return (
            <li>
                <LinkWithMessageBubble href="https://docs.frends.com/" />
            </li>
        );
    }

    if (cookiesAllowed) {
        return (
            <li id="intercom_chat_launcher">
                {/*fallback to docs.frends.com if intercom fails to load */}
                <LinkWithMessageBubble href="https://docs.frends.com/" />
            </li>
        );
    }
    // Cookies not allowed open cookie banner
    return (
        <li>
            <LinkWithMessageBubble openCookieConsentBanner={openCookieConsentBanner} />
        </li>
    );
};
